import lang from './lang'
import type { IVersionStore, IServiceItem } from '@remote/type/version'

function getServiceDescription (appid: string) {
  const $t = lang.ServiceListPage.description
  return $t[appid] || ''
}

function getServicePriority (appid: string): number {
  switch (appid) {
    case 'xos': {
      return 0
    }
    case 'xl_gx': {
      return 1
    }
    case 'xl_disk': {
      return 1
    }
    case 'xl_shell': {
      return 1
    }
    case 'xl_thumb': {
      return 4
    }
    case 'xl_dcdn': {
      return 4
    }
    case 'xl_thunder': {
      return 4
    }
    case 'xl_scrape': {
      return 4
    }
    case 'xl_backer': {
      return 4
    }
    default: {
      return 999
    }
  }
}

/** 统计列表中需要进行更新的数量 */
function computeInitCountOfNewVersion (list: IServiceItem[]) {
  let count = 0
  list.forEach(s => {
    if (s.current < s.target) {
      count += 1
    }
  })
  return count
}

// 获取用于点击上报的click_id
function getReportClickId (appid: string): string {
  switch (appid) {
    case 'xos': {
      return 'xos_sys_version'
    }
    case 'xl_gx': {
      return 'share_manage'
    }
    case 'xl_disk': {
      return 'disk_manage'
    }
    case 'xl_shell': {
      return 'file_manage'
    }
    case 'xl_thumb': {
      return 'transcode_manage'
    }
    case 'xl_dcdn': {
      return 'transmision_service'
    }
    case 'xl_thunder': {
      return 'download_service'
    }
    case 'xl_scrape': {
      return 'scrape_service'
    }
    case 'xl_backer': {
      return 'backer_service'
    }
    default: {
      return 'other'
    }
  }
}

function translateServiceList (versionInfo: IVersionStore) {
  const $t = lang.ServiceListPage
  // 将应用版本信息转化为应用列表，并计算应用展示名称
  const list = Object.keys(versionInfo).map(appid => {
    const name: string = $t[appid] || versionInfo[appid]?.name || appid
    return versionInfo[appid] ? {
      ...versionInfo[appid],
      name,
    } : versionInfo[appid]
  })

  // 列表按照指定优先级排序: XOS、xl_gx、xl_disk、xl_shell、xl_thumb、xl_dcdn、xl_thunder
  list.sort((a, b) => {
    const priorityA = getServicePriority(a.appid)
    const priorityB = getServicePriority(b.appid)
    return priorityA < priorityB ? -1 : 1
  })
  return list
}

const mocklist: IServiceItem[] = [
  { appid: 'xos', name: lang.ServiceListPage.xos, current: 0, target: 0 },
  { appid: 'xl_gx', name: lang.ServiceListPage.xl_gx, current: 0, target: 0 },
  { appid: 'xl_disk', name: lang.ServiceListPage.xl_disk, current: 0, target: 0 },
  { appid: 'xl_shell', name: lang.ServiceListPage.xl_shell, current: 0, target: 0 },
  { appid: 'xl_thumb', name: lang.ServiceListPage.xl_thumb, current: 0, target: 0 },
  { appid: 'xl_dcdn', name: lang.ServiceListPage.xl_dcdn, current: 0, target: 0 },
  { appid: 'xl_thunder', name: lang.ServiceListPage.xl_thunder, current: 0, target: 0 },
  { appid: 'xl_scrape', name: lang.ServiceListPage.xl_scrape, current: 0, target: 0 },
  { appid: 'xl_backer', name: lang.ServiceListPage.xl_backer, current: 0, target: 0 },
]

export type { IServiceItem }

export {
  mocklist,
  getServiceDescription,
  computeInitCountOfNewVersion,
  getReportClickId,
  translateServiceList,
}
